export const ITEMS_PER_PAGE = 10;
export const STARTING_PAGE = 1;
export const DEBOUNCE_SEARCH = 400;
export const SCAN_MESSAGE_DISPLAY_TIME_MS = 1500;
export const INVOICE_PRICE_DEVIATION = 0.1;
